<template>
  <div>
    <b-modal id="serviceConfiguration" title="Service Hands-on-fees" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Service Commission
        </div>
      </template>

      <div v-if="show" class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <div class="lock-header">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th rowspan="2" style="vertical-align: middle">Service</th>
                    <th :colspan="selectedStaffs.length + 1" style="text-align: center;">Commission</th>
                  </tr>
                  <tr>
                    <th style="min-width: 100px"><u>DEFAULT</u></th>
                    <th style="min-width: 100px" v-for="(staff, index) of selectedStaffs" :key="'staffHead' + index">{{ staff['name'] }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td :colspan="selectedStaffs.length + 2"><h6>Category</h6></td>
                  </tr>
                  <tr>
                    <td>
                      <label class="form-label"><u>{{ selectedSection['name'] }}</u></label>
                    </td>
                    <td>
                        <input
                          class="form-control"
                          v-model="comm[selectedSection['sectionID']]['']"
                          type="number"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td v-for="(staff, index) of selectedStaffs" :key="'staffValue' + index">
                        <input
                          class="form-control"
                          v-model="comm[selectedSection['sectionID']][staff['staffID']]"
                          type="number"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                  </tr>
                  <tr>
                    <td :colspan="selectedStaffs.length + 2"><h6>Service List</h6></td>
                  </tr>
                  <tr v-for="(service, index) of selectedServices" :key="'service_' + index">
                    <td>
                      <label class="form-label">{{ service['name'] }}</label>
                    </td>
                    <td>
                        <input
                          class="form-control"
                          v-model="comm[service['id']]['']"
                          type="number"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td v-for="(staff, index) of selectedStaffs" :key="'staffValue' + index">
                        <input
                          class="form-control"
                          v-model="comm[service['id']][staff['staffID']]"
                          type="number"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "serviceConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      services: [],
      selectedServices: [],

      selectedOutlet: {},
      selectedStaffs: [],

      show: false,

      staffs: [],
      comm: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('serviceConfiguration')

      this.loadStaff()
    },

    onOutletChange() {
      this.effort = {}

      if(this.staffs.length > 0) {
        this.loadCommission()
      }
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedServices.splice(0, this.selectedServices.length)

      for (let service of this.services) {
        if (service['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedServices.push({ id: service['skuID'], name: service['name'] })
        }
      }
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs || {}
          this.loadSection()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadService()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadService() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=1&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.services = response.data.skus
          this.filterBySection(this.selectedSection)
          this.onOutletChange()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      console.log(this.selectedOutlet)
      console.log(this.staffs)
      this.selectedStaffs = this.staffs.filter(k => k['outletID'] === this.selectedOutlet.id)
      console.log(this.selectedStaffs)

      for(let service of this.sections) {
        this.comm[service['sectionID']] = {}
        this.comm[service['sectionID']][''] = ''

        for(let staff of this.selectedStaffs) {
          this.comm[service['sectionID']][staff['staffID']] = ''
        }
      }

      for(let service of this.services) {
        this.comm[service['skuID']] = {}
        this.comm[service['skuID']][''] = ''

        for(let staff of this.selectedStaffs) {
          this.comm[service['skuID']][staff['staffID']] = ''
        }
      }
      
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_JNSkin_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_JNSkin_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false

          response.data = response.data || {"224708":{"8440":"7","8441":"7","8443":"7","37632":"6","56052":""},"224709":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224710":{"8440":"7","8441":"7","8443":"7","37632":"6","56052":""},"224711":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224713":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224715":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224716":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224717":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224718":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224719":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224722":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224723":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224724":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224725":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224726":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224728":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224729":{"8440":"7","8441":"7","8443":"7","37632":"6"},"224933":{"8440":"","8441":"","8443":"","37632":""},"225003":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225004":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225006":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225007":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225008":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225011":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225012":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225013":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225014":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225015":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225016":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225017":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225019":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225021":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225023":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225024":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225028":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225029":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225837":{"8440":"7","8441":"7","8443":"7","37632":"6"},"225842":{"8440":"7","8441":"7","8443":"7","37632":"6"},"230598":{"8440":"7","8441":"7","8443":"7","37632":"6"},"230604":{"8440":"7","8441":"7","8443":"7","37632":"6"},"230606":{"8440":"7","8441":"7","8443":"7","37632":"6"},"230607":{"8440":"7","8441":"7","8443":"7","37632":"6"},"231189":{"8440":"7","8441":"7","8443":"7","37632":"6"},"231198":{"8440":"7","8441":"7","8443":"7","37632":"6","56052":""},"234042":{"8440":"7","8441":"7","8443":"7","37632":"6"},"237134":{"8440":"6","8441":"6","8443":"6","37632":"5"},"280902":{"8440":"6","8441":"6","8443":"6","37632":"5"},"290874":{"8440":"7","8441":"7","8443":"7","37632":"6"},"290875":{"8440":"7","8441":"7","8443":"7","37632":"6"},"292516":{"8440":"7","8441":"7","8443":"7","37632":"6"},"315807":{"8440":"7","8441":"7","8443":"7","37632":"6"},"347770":{},"347771":{},"350999":{"8440":"7","8441":"7","8443":"7","37632":"6"},"353776":{"8440":"7","8441":"7","8443":"7","37632":"6"},"437375":{"8440":"7","8441":"7","8443":"7","37632":"6"},"437377":{"8440":"7","8441":"7","8443":"7","37632":"6"},"444829":{"8440":"7","8441":"7","8443":"7","37632":"6"},"444830":{"8440":"7","8441":"7","8443":"7","37632":"6"},"456193":{"8440":"7","8441":"7","8443":"7","37632":"6"},"456194":{"8440":"7","8441":"7","8443":"7","37632":"6"},"494047":{"8440":"7","8441":"7","8443":"7","37632":"6"},"514279":{"8440":"7","8441":"7","8443":"7","37632":"6"},"561234":{"8440":"7","8441":"7","8443":"7","37632":"6"},"575832":{"8440":"7","8441":"7","8443":"7","37632":"6"},"575833":{"8440":"7","8441":"7","8443":"7","37632":"6"},"622823":{"8440":"7","8441":"7","8443":"7","37632":"6"},"622824":{"8440":"7","8441":"7","8443":"7","37632":"6"},"678585":{"8440":"7","8441":"7","8443":"7","37632":"6"},"678591":{"8440":"7","8441":"7","8443":"7","37632":"6"},"678594":{"8440":"7","8441":"7","8443":"7","37632":"6"},"796442":{"8440":"7","8441":"7","8443":"7","37632":"6"},"817210":{"8440":"7","8441":"7","8443":"7","37632":"6"},"1024393":{"8440":"7","8441":"7","8443":"7","37632":"6"},"1034508":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034509":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034510":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034511":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034512":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034513":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034514":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034515":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034516":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034517":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034518":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034519":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034520":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034521":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034522":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034523":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034524":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1034543":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1037697":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038059":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038060":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038061":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038062":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038063":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038065":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038066":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038067":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038068":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038069":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038070":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038071":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038072":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038073":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038075":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038076":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038077":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038078":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038079":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038080":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038081":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038082":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038083":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038084":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038085":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1038086":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047485":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047486":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047488":{"8440":"6","8441":"6","8443":"6","37632":"5","56052":""},"1047489":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047490":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047491":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047492":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047493":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047494":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047495":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047496":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047497":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047499":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047501":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047502":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047503":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047507":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047508":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047509":{"8440":"6","8441":"6","8443":"6","37632":"5"},"1047511":{"8440":"6","8441":"6","8443":"6","37632":"5"}}

          for(let service of this.sections) {
            this.comm[service['sectionID']] = response.data[service['sectionID']] || {}
            if (typeof this.comm[service['sectionID']] == 'string') {
              this.comm[service['sectionID']] = {}
            }
            this.comm[service['sectionID']][''] = this.comm[service['sectionID']][''] || ''
          }

          for(let service of this.services) {
            this.comm[service['skuID']] = response.data[service['skuID']] || {}
            if (typeof this.comm[service['skuID']] == 'string') {
              this.comm[service['skuID']] = {}
            }
            this.comm[service['skuID']][''] = this.comm[service['skuID']][''] || ''
          }

          this.show = true

          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = this.comm
      console.log(this.comm)

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_JNSkin_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_JNSkin_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('serviceConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}

.lock-header {
	overflow: -moz-scrollbars-vertical; 
  overflow-y: scroll;
  max-height: 75vh;
}

.lock-header thead {
  position: sticky;
  top: 0;
	background-color: #fff;
	z-index: 11;
}

.lock-header td:nth-child(1) {
  position: sticky;
  left: 0;
	background-color: #fff;
  z-index: 10;
}

.lock-header tr:nth-of-type(odd) td:nth-child(1) {
    background-color: #f4f4f4;
}
</style>